import { createAsyncThunk } from "@reduxjs/toolkit";

import { getOrdersStatistic } from "@api/actions/stats";

const LOAD_STATISTIC = "LOAD_STATISTIC";

export const loadOrdersStatistic = createAsyncThunk(
  `STATS/${LOAD_STATISTIC}`,
  async () => {
    try {
      const response = await getOrdersStatistic();
      return response.data;
    } catch (err) {
      console.error(err);
    }
  },
);
